import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { IRecurringUserTask } from './recurring-user-tasks.types';

interface GetFilteredRecurringTasksQuery {
  companyId: number;
  corporationId?: number;
  includeCorporation?: boolean;
  includeMonthlySalesTaxCompletedTasks?: boolean;
  includeNpsTasks?: boolean;
}

export function useRecurringUserTasks(
  params: GetFilteredRecurringTasksQuery | null
) {
  const query = new URLSearchParams();
  if (params?.corporationId) {
    query.append('corporationId', params.corporationId?.toString());
  }

  if (params?.includeCorporation) {
    query.append('includeCorporation', 'true');
  }

  if (params?.includeMonthlySalesTaxCompletedTasks) {
    query.append('includeMonthlySalesTaxCompletedTasks', 'true');
  }

  if (params?.includeNpsTasks) {
    query.append('includeNpsTasks', 'true');
  }

  if (params?.companyId) {
    query.append('companyId', params.companyId.toString());
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: { tasks: IRecurringUserTask[] };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `recurringUserTasks?${query}`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
